export default function (el) {
  el.addEventListener('click', ({ target }) => {
    if (document.selection) {
      const range = document.body.createTextRange()

      range.moveToElementText(target)
      range.select()
    } else if (window.getSelection) {
      const range = document.createRange()

      range.selectNode(target)
      window.getSelection().removeAllRanges()
      window.getSelection().addRange(range)
    }
  })
}
